import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel, Pagination, PagingResponseModel } from '../../shared';
import { ProcessTypeFileContainerModel } from '../../../../../../models/aggregates/mrp-process';
import { Observable } from 'rxjs';
import { FilesDetailsRequest } from '../../../../../../models/file-image';


@Injectable({
  providedIn: 'root'
})
export class ProcessTypeFileService extends BaseApiTemplateService<ProcessTypeFileContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/process-type-checklist-attachments"

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/process-type-checklist-attachments"
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/process-type-checklist-attachments"
    this.httpClient = http;
  }

  addMrpAttachmentsAndDetails(guid: string, files: File[], visa: ApiVisa,
    filesDetails?: FilesDetailsRequest) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const formData: FormData = new FormData();
    files.forEach(file => formData.append('files', file));
    if (filesDetails) {
      formData.set(
        'data',
        new Blob([JSON.stringify(filesDetails)], { type: 'application/json' }),
        'data.json')
    }


    return this.httpClient.put<ApiResponseModel<any>>(
      this.apiUrl + '/add-files/backoffice-ep/' + guid,
      formData,
      this.getHttpHeader(visa)
    );
  }

  public getAttchmentByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<ProcessTypeFileContainerModel>> {
    // console.log('get by criteria bsae-api');
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/backoffice-ep' + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<ProcessTypeFileContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public deleteAttachmentFile(guid: string, visa: ApiVisa): Observable<ApiResponseModel<ProcessTypeFileContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      console.log('this.endpoint_path && visa.api_domain_url: ', visa.api_domain_url + this.endpoint_path);
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<ProcessTypeFileContainerModel>>(
      this.apiUrl + '/backoffice-ep/' + guid,
      this.getHttpHeader(visa)
    );
  }

  public getAttachmentFile(guid: string, apiVisa: ApiVisa): Observable<Blob> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<Blob>(
      this.apiUrl + '/file/backoffice-ep/' + guid,
      this.getHttpHeaderBlob(apiVisa)
    );
  }

}
